import React from 'react';

import { useReceiptDownload } from '../hooks/useReceiptDownload';

import LoadingSpinner from './LoadingSpinner';

interface FilenameProps {
  storageKey?: string;
  fileName: string;
  className?: string;
}

const Filename: React.FC<FilenameProps> = ({
  storageKey,
  fileName,
  className = '',
}) => {
  const { downloadFile, isDownloading } = useReceiptDownload();

  if (!storageKey) {
    return <span className={className}>{fileName}</span>;
  }

  return (
    <button
      type='button'
      className={`text-blue-600 hover:underline hover:text-blue-800 cursor-pointer inline-flex items-center gap-1 ${className}`}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        downloadFile(storageKey);
      }}
    >
      {fileName}
      {isDownloading && <LoadingSpinner size='xs' />}
    </button>
  );
};

export default Filename;
